module.exports = __webpack_public_path__ + "static/media/track-lief-zoals-je-bent.e8c8d6dd.png";